import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

const LoginPage: React.FC = () => {
  const { isAuthenticated, redirectToLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If already authenticated, redirect to intended destination or dashboard
    if (isAuthenticated) {
      const from = (location.state as any)?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  const handleLogin = () => {
    redirectToLogin();
  };

  const handleSignup = () => {
    navigate('/signup');
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="text-center mb-4">
                <img
                  src="/ratemytalk150.png"
                  alt="RateMyTalk Logo"
                  height="80"
                  className="mb-3"
                />
                <h2 className="card-title">Welcome Back</h2>
                <p className="text-muted">Sign in to your RateMyTalk account</p>
              </div>

              <div className="d-grid gap-2">
                <button
                  className="btn btn-primary btn-lg"
                  onClick={handleLogin}
                >
                  <i className="fas fa-sign-in-alt me-2"></i>
                  Sign In with Cognito
                </button>
              </div>

              <hr className="my-4" />

              <div className="text-center">
                <p className="mb-0">
                  Don't have an account?{' '}
                  <button
                    className="btn btn-link p-0"
                    onClick={handleSignup}
                  >
                    Sign up here
                  </button>
                </p>
              </div>

              <div className="mt-4">
                <div className="alert alert-info">
                  <i className="fas fa-info-circle me-2"></i>
                  <strong>Secure Authentication:</strong> We use AWS Cognito for secure,
                  enterprise-grade authentication with optional multi-factor authentication.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
